import { getSectors, removeSector, addSector, updateSector } from "../services/sectors";
import DataTable from "../components/Table/DataTable";
import { roles } from "../utils/roles";

const headCells = [
  {
    field: "name",
    headerName: "Name",
    sortable: true,
    editable: false,
    isOnTable: true,
    type: "textField",
    flex: 1,
    filterable: false,
    isRequired: true,
    isOnFilter: true,
    helperText: "Please provide a name.",
  },
];

const entity = {
  tableId: "sectors",
  label: "sector",
};

const permissions = {
  read: [roles.ALL],
  delete: [roles.SUPERADMIN],
  create: [roles.SUPERADMIN],
  update: [roles.SUPERADMIN],
};

export default function SectorsPages() {
  return <DataTable permissions={permissions} entity={entity} fetchData={getSectors} addData={addSector} deleteData={removeSector} updateData={updateSector} headCells={headCells} />;
}
